import React, { useEffect, useState } from "react";
import { AUDIT_CALLING_DETAILS_REPORT } from "../../constants";
import axios from "axios";
import dayjs from "dayjs";
import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
import ConnectedCallTable from "./ConnectedCallTable";
import MissedCallTable from "./MissedCallTable";
import FilterComponent from "./FilterComponent";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterListIcon from "@mui/icons-material/FilterList";
import Loader from "../reusable Component/Loader";

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  };

function AgentIncomingReport({}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"), // 7 days ago
    endDate: dayjs().format("YYYY-MM-DD"), // Today
  });

  const [callStatistics, setCallStatistics] = useState([]);
  const [metricData, setMetricData] = useState([]);


const [tabValues, setTabValues] = useState(0); // Default to the first tab

// Handle tab change
const handleTabChange = (event, newValue) => {
  setTabValues(newValue); // Update the current tab index
};

const [filterShow, setFilterShow] = useState(false);




  return (
    <>
    {loading && <Loader open={loading} />}
    <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, paddingLeft: "12px", flexGrow: 1 }}
        >
          Incoming Call Report
        </Typography>

        {/* IconButton aligned to the right */}
        <IconButton
          onClick={() => setFilterShow((prev) => !prev)}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FilterListIcon />
        </IconButton>

        {/* IconButton aligned to the right */}
        {/* <IconButton
          onClick={handleExport}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FileDownloadIcon />
        </IconButton> */}
      </Box>

      {filterShow && (
        <FilterComponent
          filters={filters}
          setFilters={setFilters}
          data={callStatistics}
          setFilterShow={setFilterShow}
        ></FilterComponent>
      )}

      <Box
        display="flex"
        justifyContent="space-between"
        gap="16px"
        sx={{
          padding: "16px",
          backgroundColor: "#EEF0F4",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        {/* Total Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Total Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.totalCalls || 0}
          </Typography>
        </Box>

        {/* Connected Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Connected Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.connectedCalls || 0}
          </Typography>
        </Box>

        {/* Missed Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Missed Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.missedCalls || 0}
          </Typography>
        </Box>

        {/* Total Talk time */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Total Connected Time
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.totalDuration || 0}
          </Typography>
        </Box>

        
      </Box>

      <Tabs
        value={tabValues} // Current selected tab
        onChange={handleTabChange} // Handle tab change
        aria-label="Call Statistics Tabs"
      >
        {/* Tab for Connected Calls */}
        <Tab
          label={`Connected (${metricData.connectedCalls || 0})`}
          id="tab-0"
          aria-controls="tabpanel-0"
        />
        {/* Tab for Missed Calls */}
        <Tab
          label={`Missed (${metricData.missedCalls || 0})`}
          id="tab-1"
          aria-controls="tabpanel-1"
        />
      </Tabs>

      {/* Tab Panels */}
      <TabPanel value={tabValues} index={0}>
        <ConnectedCallTable filters={filters} setFilters={setFilters} setMetricData={setMetricData} setLoading={setLoading} />
      </TabPanel>
      <TabPanel value={tabValues} index={1}>
        <MissedCallTable filters={filters} setFilters={setFilters} setMetricData={setMetricData} setLoading={setLoading} />
      </TabPanel>
    </>
  );
}
export default AgentIncomingReport;
